import { toQueryString } from 'utils/utils';

export async function apiPrime({ method, path, query, body }) {
	if (typeof window === 'undefined') {
		throw new Error('Trying to request server-side');
	}

	let url = `https://showtimes-v2.s-prod.pow.io/v2.0/primenights${path || '/'}`;
	if (query) {
		url += toQueryString(query);
	}

	const fetchOptions = {
		method
	};

	if (body) {
		fetchOptions.headers = {
			'content-type': 'application/json'
		};
		fetchOptions.body = JSON.stringify(body);
	}

	const res = await fetch(url, fetchOptions);

	if (!res.ok) {
		throw res.status || res.error || res;
	}

	return res.json();
}